export const ITEM_UPLOAD_URL = '/items/new'
